import React from 'react';

const CandidateChatbotConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/bot',
            component: React.lazy(() => import('./CandidateChatbot'))
        }
    ]
};

export default CandidateChatbotConfig;